export enum TicketAdminGroupType {
  ideasAdministrationGroupIds = 'ideasAdministrationGroupIds',
  problemsAdministrationGroupIds = 'problemsAdministrationGroupIds',
}
